import { render, staticRenderFns } from "./DrawerMenuItems.vue?vue&type=template&id=85968fa6&scoped=true"
import script from "./DrawerMenuItems.vue?vue&type=script&lang=js"
export * from "./DrawerMenuItems.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenuItems.vue?vue&type=style&index=0&id=85968fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85968fa6",
  null
  
)

export default component.exports